import React, { useState } from 'react';
import cx from 'classnames';

import { withTranslation } from '../../i18n';
import Button from '../UI/Button';
import styles from './styles.css';

const CrewTypeSelector = ({ t, onChange }) => {
  const [type, setType] = useState(null);

  return (
    <div className={styles.crewTypeSelector}>
      <h3>{t('registerAs')}</h3>

      <div className={styles.crewTypeOptions}>
        <button
          className={cx(styles.crewTypeOption, {
            [styles.isActive]: type === 'crew',
          })}
          onClick={() => {
            setType('crew');
          }}
        >
          {t('crewTypes.crew')}
        </button>
        <button
          className={cx(styles.crewTypeOption, {
            [styles.isActive]: type === 'media_crew',
          })}
          onClick={() => {
            setType('media_crew');
          }}
        >
          {t('crewTypes.mediaCrew')}
        </button>
      </div>

      {type && (
        <Button
          className="mt-5"
          onClick={() => {
            onChange(type);
          }}
        >
          {t('next')}
        </Button>
      )}
    </div>
  );
};

export default withTranslation('common')(CrewTypeSelector);
